import React, {useEffect, useState} from "react"
import {useLocation} from "react-router-dom"
import {useAuth} from "../../../context/AuthProvider"

type ProtectedRouteProps = {
    children: React.ReactElement
}

const ProtectedRoute = ({children}: ProtectedRouteProps) => {
    const auth = useAuth()
    const location = useLocation()

    const [checked, setChecked] = useState(false)
    const [authenticated, setAuthenticated] = useState(false)

    useEffect(() => {
        const checkAuth = async () => {
            if (auth.isAuthenticated()) {
                setAuthenticated(true)
                setChecked(true)
                return
            }

            const success = await auth.fetchToken()

            if (success || auth.isAuthenticated()) {
                setAuthenticated(true)
                setChecked(true)
                return
            }

            auth.login(location.pathname + location.search + location.hash)
        }

        checkAuth()
    }, [location.pathname, location.search, location.hash])

    if (!checked || !authenticated) {
        return null
    }

    return children
}

export default ProtectedRoute